import Section from 'app/frontend/base/components/Section'
import { useGuild } from 'app/frontend/base/config/context/guild'
import PremiumBenefits from 'app/frontend/base/pages/GuildDashboard/components/PremiumBenefits'

const GuildPremium = () => {
  const { guild } = useGuild()

  return (
    <Section title={`Premium | ${guild?.name}`}>
      <h2>Premium</h2>
      <PremiumBenefits
        guild={guild}
        legacyTier={guild?.legacyPatron?.details?.pledge_tier}
        benefits={guild?.premiumBenefits || []}
      />
    </Section>
  )
}

export default GuildPremium
